import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { local420Api } from "../api/local420Api";
import { Contractor_Entity } from "../../entities/contractor";
import { Ids } from "../../reducers/rhapsody";

const contractorsAdapter = createEntityAdapter<Contractor_Entity>();
const initialState = contractorsAdapter.getInitialState();

export const contractorEndpoints = local420Api.injectEndpoints({
  endpoints: (build) => ({
    getContractors: build.query<EntityState<Contractor_Entity>, void>({
      query: () => `contractors`,
      transformResponse: (responseData: Contractor_Entity[]) => {
        return contractorsAdapter.setAll(initialState, responseData);
      },
      providesTags: ["contractors"],
    }),
    getContractor: build.query<Contractor_Entity, Ids>({
      query: (arg) => {
        return {
          url: `contractors/${arg.id}`,
          params: {
            sourceID: arg.sourceID,
            sourceRecordID: arg.sourceRecordID,
          },
        };
      },
      providesTags: ["contractors"],
    }),
    createContractor: build.mutation<
      Contractor_Entity,
      Partial<Contractor_Entity>
    >({
      query: (body) => ({
        method: "POST",
        body,
        url: `contractors`,
      }),
      invalidatesTags: ["contractors"],
    }),
    updateContractor: build.mutation<
      void,
      { id: number; body: Partial<Contractor_Entity> }
    >({
      query: (args) => ({
        method: "PUT",
        body: args.body,
        url: `contractors/${args.id}`,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "contractors", id },
        "contractors",
      ],
    }),
    deleteContractor: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `contractors/${id}`,
      }),
      invalidatesTags: ["contractors"],
    }),
  }),
});

export const {
  useGetContractorQuery,
  useGetContractorsQuery,
  useCreateContractorMutation,
  useDeleteContractorMutation,
  useUpdateContractorMutation,
} = contractorEndpoints;

export default contractorEndpoints;
